export function compareColumnPositions(
  a: { id: string },
  b: { id: string },
  pinnedColumns: Record<string, 'left' | 'right' | undefined>,
  columnOrders: Record<string, number>,
): number {
  const isAPinned = pinnedColumns[a.id];
  const isBPinned = pinnedColumns[b.id];
  const isAPinnedLeft = isAPinned === 'left';
  const isBPinnedLeft = isBPinned === 'left';
  const isAPinnedRight = isAPinned === 'right';
  const isBPinnedRight = isBPinned === 'right';

  // Left pinned columns come first
  if (isAPinnedLeft && !isBPinnedLeft) return -1;
  if (!isAPinnedLeft && isBPinnedLeft) return 1;

  // Right pinned columns come last
  if (isAPinnedRight && !isBPinnedRight) return 1;
  if (!isAPinnedRight && isBPinnedRight) return -1;

  // Within the same pinned state, use column orders
  if (isAPinnedLeft && isBPinnedLeft) {
    return (columnOrders[a.id] ?? 0) - (columnOrders[b.id] ?? 0);
  }

  if (isAPinnedRight && isBPinnedRight) {
    return (columnOrders[a.id] ?? 0) - (columnOrders[b.id] ?? 0);
  }

  // For unpinned columns, use regular order
  return (columnOrders[a.id] ?? 0) - (columnOrders[b.id] ?? 0);
}
